import TeamCard from "./TeamCard";
import { meetTheTeam } from "../constants";

const MeetTeam = () => {
  return (
    <div className="mt-4 flex flex-col 2xl:m-auto px-4 md:px-12 w-full py-16 gap-4 bg-white">
      <div className="flex flex-col items-center justify-center gap-5 mb-8">
        <h1 className="text-5xl font-bold text-bblack-5 text-center">
          Meet the team
        </h1>
        <p className="text-ashShade-20 text-center font-medium text-lg lg:w-[60ch] md:w-[50ch] w-full">
          Everyone at Bankole is here for the same reason: we see it as our duty
          to improve the user experience of the world by guiding clients through
          impactful digital transformations.
        </p>
      </div>
      <div className="w-full flex justify-center items-center">
        <div className="flex flex-wrap justify-center gap-5 items-center max-w-[1236px] 2xl:max-w-[1500px] 2xl:justify-center 2xl:items-center w-full">
          {meetTheTeam.map((member, index) => (
            <TeamCard
              key={index}
              name={member.name}
              role={member.role}
              image={member.image}
              description={member.description}
              bgColor={member.bgColor}
              roleColor={member.roleColor}
            />
          ))}
        </div>
      
      </div>
    </div>
  );
};

export default MeetTeam;
